import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand p-100" style={{ background: "#F8F8FB" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>
              Experience Top-notch .Net Development Services with Our Top-tier
              .Net Developers
            </h2>
            <p>
              Use the benefits of our great experience in .NET development
              services to, change the way your business works. Our top-tier .NET
              developers bring unique solutions oriented to their performance,
              safety, and expansion to fit your requirements.
            </p>
          </Col>
          <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>.NET Software Development</h4>
                  <p>
                    Our .NET services of software development provide all stages
                    of development starting with ideas and ending with
                    implementation. We provide business-driven development
                    services to implement custom, robust, and scalable
                    solutions. Leveraging the latest .NET technologies we
                    integrate well and provide a better experience to the
                    end-user.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>.NET Upgradation and Migration</h4>
                  <p>
                    Be updated with our .NET upgrade and migration services. We
                    assist you in migrating your organization from old systems
                    to advanced .NET platforms without any hitch and with ease.
                    Our specialists make sure that your business affairs are not
                    a hassle to maintain, optimize, protect, or update with the
                    newest. NET advancements.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>.NET QA & Testing</h4>
                  <p>
                    Always aim at the best quality of your .NET applications
                    with our end-to-end QA and testing services. Our testing
                    procedures involve the elimination of bugs and problems
                    before the deployment of the software, thus offering clients
                    reliable, high-quality software. In this method, we instill
                    performance, security, and usability into the application
                    for it to be perfect.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>.NET Integration Services</h4>
                  <p>
                    Get the most out of your .NET applications with our
                    integration services for a smooth operation. In this case,
                    we major in linking your .NET to integrate with other
                    systems, APIs, and databases of the other parties that need
                    the solution. Our integration expertise helps to avoid
                    interruption in data sharing, increase functional
                    capabilities, and optimize business processes.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Cloud-based .NET Solutions</h4>
                  <p>
                    Welcome the future through a cloud-based solution. NET
                    solutions. We also build, implement, and maintain efficient,
                    large-scale .NET applications on the most popular cloud
                    environments like Azure, endowed with flexibility, low
                    costs, and availability. With our cloud solutions, you can
                    maximize the cloud’s abilities and ensure ultimate stability
                    and speed.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>.NET Enterprise Solutions</h4>
                  <p>
                    Redeem your enterprise with our tailor-made .NET enterprise
                    solutions. Web and mobile application development is defined
                    as creating solutions that meet the needs of your
                    organization and are changeable, reliable, and effective. We
                    provide solutions to optimize business operations bring
                    value to your organization and make your enterprise thrive
                    in the digital age.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
